import React from "react";
import PropTypes from "prop-types";

const CDCAddressDisplay = ({ address }) => {
  return (
    <div>
      <div>{address.address_1}</div>
      {address.address_2 && <div>{address.address_2}</div>}
      <div>
        {address.city} {address.state} {address.zip_code}
      </div>
      <div>{address.country}</div>
    </div>
  );
};

CDCAddressDisplay.propTypes = {
  address: PropTypes.object,
};

export default CDCAddressDisplay;
